module.exports = __webpack_public_path__ + "images/landing/moving-trucks/bellhops-truck-scaled.jpg";